import React from 'react';
import { Eye, PhoneIcon, MailIcon } from 'lucide-react';
const mockUsers = [{
  id: 1,
  name: 'Carlos Mendoza',
  identification: '12345678',
  email: 'carlos@ejemplo.com',
  phone: '987654321',
  amount: 5000,
  status: 'pending'
}, {
  id: 2,
  name: 'Ana Rodríguez',
  identification: '87654321',
  email: 'ana@ejemplo.com',
  phone: '123456789',
  amount: 12000,
  status: 'review'
}, {
  id: 3,
  name: 'Luis Gómez',
  identification: '45678912',
  email: 'luis@ejemplo.com',
  phone: '456789123',
  amount: 3000,
  status: 'approved'
}];
const getStatusBadge = status => {
  const statusMap = {
    pending: {
      color: 'yellow',
      label: 'Pendiente'
    },
    review: {
      color: 'blue',
      label: 'En Revisión'
    },
    approved: {
      color: 'green',
      label: 'Aprobado'
    },
    rejected: {
      color: 'red',
      label: 'Rechazado'
    }
  };
  const statusInfo = statusMap[status] || statusMap.pending;
  return <span className={`px-2 py-1 inline-flex text-xs leading-5 font-semibold rounded-full bg-${statusInfo.color}-100 text-${statusInfo.color}-800`} data-id="element-634">
      {statusInfo.label}
    </span>;
};
export const PotentialTable = () => {
  return <div className="bg-white rounded-lg shadow overflow-hidden" data-id="element-635">
      <div className="overflow-x-auto" data-id="element-636">
        <table className="min-w-full divide-y divide-gray-200" data-id="element-637">
          <thead className="bg-gray-50" data-id="element-638">
            <tr data-id="element-639">
              <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-640">
                Nombre
              </th>
              <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-641">
                Identificación
              </th>
              <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-642">
                Contacto
              </th>
              <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-643">
                Monto Solicitado
              </th>
              <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-644">
                Estado
              </th>
              <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-645">
                Acciones
              </th>
            </tr>
          </thead>
          <tbody className="bg-white divide-y divide-gray-200" data-id="element-646">
            {mockUsers.map((user, index) => <tr key={user.id} className={index % 2 === 0 ? 'bg-white' : 'bg-gray-50'} data-id="element-647">
                <td className="px-6 py-4 whitespace-nowrap" data-id="element-648">
                  <div className="text-sm font-medium text-gray-900" data-id="element-649">
                    {user.name}
                  </div>
                </td>
                <td className="px-6 py-4 whitespace-nowrap" data-id="element-650">
                  <div className="text-sm text-gray-500" data-id="element-651">
                    {user.identification}
                  </div>
                </td>
                <td className="px-6 py-4" data-id="element-652">
                  <div className="text-sm text-gray-500" data-id="element-653">
                    <div className="flex items-center" data-id="element-654">
                      <MailIcon className="h-4 w-4 mr-1" data-id="element-655" />
                      {user.email}
                    </div>
                    <div className="flex items-center mt-1" data-id="element-656">
                      <PhoneIcon className="h-4 w-4 mr-1" data-id="element-657" />
                      {user.phone}
                    </div>
                  </div>
                </td>
                <td className="px-6 py-4 whitespace-nowrap" data-id="element-658">
                  <div className="text-sm font-medium text-gray-900" data-id="element-659">
                    ${user.amount.toLocaleString()}
                  </div>
                </td>
                <td className="px-6 py-4 whitespace-nowrap" data-id="element-660">
                  {getStatusBadge(user.status)}
                </td>
                <td className="px-6 py-4 whitespace-nowrap text-sm font-medium" data-id="element-661">
                  <button className="text-blue-600 hover:text-blue-900" data-id="element-662">
                    <Eye className="h-5 w-5" data-id="element-663" />
                  </button>
                </td>
              </tr>)}
          </tbody>
        </table>
      </div>
    </div>;
};